import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { LimitTypeListPage } from '@/features/limitTypes/pages/LimitTypeListPage';
import { listSearchSchema } from '@/utils/listSearch';

export const Route = createFileRoute('/_auth/settings/limit-types')({
  validateSearch: listSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Limit Types">
      <Suspense fallback={<PageLoader />}>
        <LimitTypeListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
